module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Communication/Incoming-mail-108bd53bb3a771c572b74274b09eed7e.svg";